import { Component, input, output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "fh-filter-bar",
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: "./filter-bar.component.html",
  styleUrls: ["./filter-bar.component.scss"],
})
export class FilterBarComponent {
  // Inputs
  showResetButton = input<boolean>(true);

  // Outputs
  resetFilters = output<void>();
}
